const NUMBER_OF_ROWS: any = [
    {
        code: 3,
        title: 3,
    },
    {
        code: 5,
        title: 5,
    },
    {
        code: 7,
        title: 7,
    }
];

export default NUMBER_OF_ROWS;


// WEBPACK FOOTER //
// ./src/constants/NUMBER_OF_ROWS.ts